import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import { Badge } from 'react-bootstrap'
import { FMT } from 'utils'

/**
 * Simplifies footer logic.
 * The row is shown if any is true:
 *   - show or rate are > 0
 *   - value is non-zero, but not null
 *   - show is forced to true
 * @todo document which rows could produce different values
 * @param title
 * @param skipTR
 * @param colSpan
 * @param show
 * @param hide
 * @param value
 * @param icon shows before the title
 * @param badge shows before the icon
 * @param badgeVariant
 * @param rate
 * @param prefix Anything that should show before the badge and the icon
 */
export default function FooterRow({ title, skipTR, colSpan = 2, show, hide = false, value = null, icon = null, badge = null, badgeVariant = 'secondary', rate = null, prefix = null }) {
	const rateEl = rate? `(${FMT.percent(rate)})` : null
	const prefixContent = <>
		{prefix}
		{badge && (typeof badge == 'string'? <Badge variant={badgeVariant} icon={icon}>{badge}</Badge> : badge)}
		{icon && <Icon icon={icon}/>}
	</>

	if (!hide && (show === true || show > 0 || rate > 0 || (value != 0 && value !== null))) {
		let cells = <>
			<th colSpan={value == null? colSpan + 1 : colSpan}>
				<span className="d-flex align-items-center justify-content-end">{prefixContent} {title} {rateEl}</span>
			</th>
			{value == null? null : <td width={Number.isInteger(value)? 1 : null}>{Number.isInteger(value)? FMT.money(value) : value}</td>}
		</>

		return skipTR? cells : <tr>{cells}</tr>
	}

	return null
}

FooterRow.propTypes = {
	rate : PropTypes.number,
	icon : PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	show : PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
	hide : PropTypes.bool,
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
}
